export interface IMortalityCalculations {
    recipientId: number,
    isOnDialysis: boolean,
    hasDiabetes: boolean,
    yearsOnDialysis: number,
    age: number,
    a: number,
    constantA: number,
    b: number,
    constantB: number,
    c: number,
    constantC: number,
    d: number,
    constantD: number,
    e: number,
    constantE: number,
    muliplierOfE: number,
    f: number,
    constantF: number,
    t: number,
    s: number,
    m: number,
    mPreExponent: number,
    survivalYearsToCalculate: number,
    chanceOfSurvival: number,
    riskPercent: number
}